export default __webpack_public_path__ + "static/media/cushions.75f53d32.png";